// Filtros da lista de autos ↔ query string (spec 2026-10-15-painel-autos-infracao,
// PR 1). A URL é a fonte de verdade dos filtros APLICADOS: o painel (PR 2) linka
// para cá com filtro, o link pode ser compartilhado, e a tela busca a cada
// mudança de location.search — o que elimina a closure obsoleta do antigo
// "Limpar" (setTimeout(buscarRegistros) rodava com os filtros velhos).
//
// As chaves são as mesmas que o backend aceita (filtrosAutoInfracao.js).

export const CHAVES = [
  'data_inicio', 'data_final', 'nu_ai', 'nu_infracao',
  'status_ai', 'status_acompanhamento', 'rf_lavratura', 'posto',
];

export const FILTROS_VAZIOS = Object.freeze(
  CHAVES.reduce((acc, k) => ({ ...acc, [k]: '' }), {}),
);

export function filtrosDaQuery(search) {
  const p = new URLSearchParams(search || '');
  const filtros = { ...FILTROS_VAZIOS };
  CHAVES.forEach((k) => {
    if (p.has(k)) filtros[k] = p.get(k);
  });
  // Até 9 dígitos, como o backend aceita (paginacao em filtrosAutoInfracao.js).
  const bruto = p.get('pagina') || '';
  const n = /^\d{1,9}$/.test(bruto) ? Number(bruto) : 0;
  return { filtros, pagina: n > 0 ? n : 1 };
}

export function paramsDaApi(filtros) {
  const params = {};
  CHAVES.forEach((k) => {
    const v = (filtros[k] || '').trim();
    if (v) params[k] = v;
  });
  return params;
}

export function queryDosFiltros(filtros, pagina = 1) {
  const p = new URLSearchParams(paramsDaApi(filtros));
  if (pagina > 1) p.set('pagina', String(pagina));
  const s = p.toString();
  return s ? `?${s}` : '';
}

// Estado da tela depois de uma busca (lista + /estatisticas). Falha ZERA tudo:
// sem isso, um 400 deixava os números da busca anterior na tela, sob a URL e o
// formulário da busca nova — e o Exportar continuava habilitado sobre eles.
export function resultadoDaBusca({ lista, stats, erro }) {
  if (erro) {
    const doServidor = erro.response && erro.response.data && erro.response.data.erro;
    return {
      registros: [], totalRegistros: 0, totalPaginas: 0, estatisticas: null,
      erro: doServidor || 'Erro ao carregar registros.',
    };
  }
  return {
    registros: lista.data.registros,
    totalRegistros: lista.data.total,
    totalPaginas: lista.data.total_paginas,
    estatisticas: stats.data,
    erro: null,
  };
}

// Como ir para (filtros, página). Para a MESMA URL, um push não muda
// location.search e a tela não refaz nada: "Limpar" com a URL já vazia não
// limpava o formulário, e "Buscar" de novo depois de um erro não tentava de
// novo. Nesse caso: replace com `refazer`, que a tela traduz num state novo.
// `substituir`: correção automática (página além do total) troca a entrada do
// histórico em vez de empilhar — senão o Voltar caía de novo na página
// inexistente e era corrigido para frente outra vez (revisão do PR 4, I-1).
export function navegacaoPara(searchAtual, filtros, pagina = 1, { substituir = false } = {}) {
  const search = queryDosFiltros(filtros, pagina);
  const mesma = search === (searchAtual || '');
  return { metodo: mesma || substituir ? 'replace' : 'push', search, refazer: mesma };
}

// A exportação pede no máximo 10.000 linhas; com filtro por posto o total passa
// disso com facilidade (Nhangapi tem ~122 mil). Quem exporta precisa saber.
export function avisoDeCorte(total, exportados) {
  if (exportados >= total) return null;
  const n = (v) => v.toLocaleString('pt-BR');
  return `Exportados ${n(exportados)} de ${n(total)} registros (limite da exportação). Filtre mais para exportar tudo.`;
}

// Filtros aplicados que o formulário não mostra (#394): RF não tem campo, e um
// status que não está nas opções (vocabulário antigo, link do painel) aparece
// como "Todos" no select controlado. Sem isto, a lista filtra sem que a tela diga.
const SEM_CAMPO = [['rf_lavratura', 'RF']];
const SELECTS = [['status_ai', 'Status AI'], ['status_acompanhamento', 'Acompanhamento']];

export function filtrosForaDoFormulario(filtros, opcoes) {
  const fora = SEM_CAMPO.filter(([k]) => filtros[k]).map(([chave, rotulo]) => ({ chave, rotulo, valor: filtros[chave] }));
  SELECTS.forEach(([chave, rotulo]) => {
    const lista = opcoes[chave] || [];
    // Opções ainda não carregadas: não dá para saber se o valor é desconhecido.
    if (filtros[chave] && lista.length && !lista.includes(filtros[chave])) {
      fora.push({ chave, rotulo, valor: filtros[chave] });
    }
  });
  return fora;
}

// Link velho para uma página que não existe mais (a base é reimportada todo mês):
// devolve a última página, ou null se não há o que corrigir.
export const paginaCorrigida = (pagina, totalPaginas) =>
  (totalPaginas > 0 && pagina > totalPaginas ? totalPaginas : null);

export const soDigitos = (v) => String(v || '').replace(/\D/g, '');
